module.exports = __webpack_public_path__ + "img/stamp-island-designer-green.d9d99335.png";